export const lazyTypes = new Map()